import { Navigate } from "react-router-dom";

/**
 * REQ-CQC-COMPLIANCE-001 — single consolidated dashboard.
 *
 * The legacy `/app/cqc` page is preserved only as a permanent redirect to the
 * unified Compliance Dashboard at `/app/dashboard/compliance`. Any old links,
 * emails or bookmarks continue to work.
 */
export default function CqcDashboard() {
  return <Navigate to="/app/dashboard/compliance" replace data-testid="cqc-redirect" />;
}
